export default "__VITE_PUBLIC_ASSET__6919fdd5__"